import script from "./Pages.vue?vue&type=script&setup=true&lang=js"
export * from "./Pages.vue?vue&type=script&setup=true&lang=js"

import "./Pages.vue?vue&type=style&index=0&id=0925c6c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0925c6c7"]])

export default __exports__